import { TFunction } from 'i18next'
import SyslogConfigRestService from '../rest/SyslogRestConfigService'

class SyslogConfigService {
  static async getConfig() {
    return SyslogConfigRestService.getConfig()
  }

  static async createConfig(syslogConfig: any, t: TFunction, setSyslogConfig: React.Dispatch<any>) {
    try {
      await SyslogConfigRestService.createConfig(syslogConfig)
      const updatedConfig = await SyslogConfigService.getConfig()
      setSyslogConfig(updatedConfig)
      return t('syslogConfig.createSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async updateConfig(syslogConfig: any, t: TFunction, setSyslogConfig: React.Dispatch<any>) {
    try {
      await SyslogConfigRestService.updateConfig(syslogConfig)
      const updatedConfig = await SyslogConfigService.getConfig()
      setSyslogConfig(updatedConfig)
      return t('syslogConfig.updateSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async deleteConfig(id: number, t: TFunction, setSyslogConfig: React.Dispatch<any>) {
    try {
      await SyslogConfigRestService.deleteConfig(id)
      const updatedConfig = await SyslogConfigService.getConfig()
      setSyslogConfig(updatedConfig)
      return t('syslogConfig.deleteSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default SyslogConfigService
